import { Locale } from 'date-fns';
import { enGB as en, ru, zhCN as zh } from 'date-fns/locale';

export const enum ELanguage {
    RU = 'ru',
    EN = 'en',
    ZH = 'zh'
}

export const locales: Record<PropertyKey, Locale> = {
    en,
    ru,
    zh
};

export const defaultLocale = ru;

export const defaultLocaleString = 'ru';

export const supportedLanguages = [ELanguage.ZH, ELanguage.RU];
